import request from '../request/request';
import {handleRes} from '../utils/utils';


interface HandleResInterface {
  success: any,
  fail: any,
}


const submitLogin = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request.POSTAccLogIn(params);
    const result = handleRes(res, {
      failMes: res.msg
    });
    resolve(result);
  });
};

const submitLogout = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request.POSTAccLogOut(params);
    console.log(res,'-----res');
    const result = handleRes(res, {
      failMes: res.msg
    });
    resolve(result);
  });
};

const getAccLoginAuthority = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request.GETAccLoginAuthority(params);
    const result = handleRes(res, {
      failMes: res.msg
    });
    resolve(result);
  });
};


export {
  submitLogin,
  submitLogout,
  getAccLoginAuthority,
};
